import React, { useState } from "react";
import { api } from "../../lib/api";
import { BTN, errMsg } from "./QuickForm";

// Run a checklist: pass / fail / N/A per item (large targets); failed items become internal punch items on submit.
export default function InspectionRunner({ ins, onDone }) {
  const [res, setRes] = useState({});
  const [err, setErr] = useState("");
  const submit = () => api.post(`/hse/inspections/${ins.id}/complete`, { results: ins.items.map((i) => ({ item_id: i.id, result: res[i.id], note: "" })).filter((x) => x.result) })
    .then(onDone).catch((e) => setErr(errMsg(e)));
  const revert = (d) => api.post(`/hse/inspections/${ins.id}/deficiencies/${d.punch_id}/revert`, { reason: "Recorded in error (reverted from inspection)" }).then(onDone).catch((e) => setErr(errMsg(e)));
  return (
    <li className="border border-erf-borderCream rounded bg-white p-3 space-y-2 text-sm" data-testid={`hse-insp-${ins.id}`}>
      <p className="font-semibold">{ins.template_name} · {ins.scheduled_for} · {ins.state}</p>
      {ins.state === "scheduled" && ins.items.map((i) => (
        <div key={i.id} className="flex flex-wrap items-center gap-2" role="group" aria-label={i.text}>
          <span className="min-w-0 flex-1 break-words">{i.text}</span>
          {["pass", "fail", "na"].map((r) => (
            <button key={r} type="button" aria-pressed={res[i.id] === r} onClick={() => setRes({ ...res, [i.id]: r })}
              className={`min-h-[48px] min-w-[56px] rounded border text-sm ${res[i.id] === r ? "bg-erf-dark text-white border-erf-dark" : "border-erf-borderCream"}`}
              data-testid={`hse-insp-${ins.id}-${i.id}-${r}`}>{r === "na" ? "N/A" : r}</button>))}
        </div>))}
      {ins.state === "scheduled" && <button type="button" className={`${BTN} bg-erf-dark text-white`} onClick={submit} data-testid={`hse-insp-submit-${ins.id}`}>Complete inspection</button>}
      {(ins.deficiencies || []).map((d) => (
        <p key={d.punch_id} className="text-xs" data-testid={`hse-insp-def-${d.punch_id}`}>{d.number} deficiency {d.reverted ? "(reverted)" : ""}
          {!d.reverted && <button type="button" className="ml-2 underline min-h-[44px]" onClick={() => revert(d)} data-testid={`hse-insp-revert-${d.punch_id}`}>Revert</button>}</p>))}
      {err && <p role="alert" className="text-red-700" data-testid={`hse-insp-error-${ins.id}`}>{err}</p>}
    </li>
  );
}
